global.modules.set({
  is_booted: false,
  async init(context) {
    if (this.is_booted) {
      return;
    }
    this.is_booted = true;

    let btnShowProfile = document.querySelectorAll('[data-to-profile]');
    let btnHideProfile = document.querySelectorAll('[data-to-content]');
    
    if (btnShowProfile.length) {
      btnShowProfile.forEach(btn => {
        btn.addEventListener('click', () => {
          let asideProfile = document.querySelector('.profile-side');
          if (!asideProfile) return
          asideProfile.scrollTop = 0;
          asideProfile.classList.add('active')
          $('body').addClass('lock');
        })
      })
    }
    
    if (btnHideProfile.length) {
      btnHideProfile.forEach(btn => {
        btn.addEventListener('click', () => {
          let asideProfile = document.querySelector('.profile-side.active');
          if (!asideProfile) return
          asideProfile.classList.remove('active')
          $('body').removeClass('lock');
        })
      })
    }
  }
})